import React from 'react';

type Props = {
  fill?: string,
}

const Play = ({ fill }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg2592"
    version="1.1"
    viewBox="0 0 9.8093395 10.78689"
    height="10.78689mm"
    width="9.8093395mm"
  >
    <defs
      id="defs2586"
    />
    <g
      transform="translate(-103.95247,-117.07084)"
      id="layer1"
    >
      <path
        d="m 105.50046,118.12918 c -0.44168,0 -0.48966,0.54398 -0.48966,0.77752 v 7.11517 c 0,0.23389 0.048,0.77752 0.48966,0.77752 0.1584,0 0.34854,-0.0614 0.54998,-0.17744 l 6.16162,-3.55741 c 0.31256,-0.18027 0.49142,-0.39935 0.49142,-0.60008 0,-0.20108 -0.17886,-0.4198 -0.49142,-0.60043 l -6.16162,-3.55741 c -0.20144,-0.11606 -0.39158,-0.17744 -0.54998,-0.17744 m 0,9.72855 c -0.77047,0 -1.54799,-0.56762 -1.54799,-1.83586 v -7.11517 c 0,-1.26824 0.77752,-1.83586 1.54799,-1.83586 0.3489,0 0.7119,0.1076 1.07915,0.31927 l 6.16161,3.55776 c 0.64876,0.3743 1.02059,0.9271 1.02059,1.51659 0,0.58914 -0.37183,1.14194 -1.02059,1.51624 l -6.16161,3.55776 c -0.36725,0.21167 -0.73025,0.31927 -1.07915,0.31927"
        style={{
          fill,
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          strokeWidth: 0.352777,
        }}
        id="path102"
      />
    </g>
  </svg>
);

Play.defaultProps = {
  fill: '#231f20',
};

export default Play;
